import React from "react";
import { Container, Row, Col } from "react-bootstrap";

var Api_url = process.env.GATSBY_API_URL;
var url = Api_url + `/api/wm/yearwise/team/members/lists`;
console.log('API_URL=' + Api_url + ', url=' + url);

var image1 = Api_url + `/assets/website/images/play_store.png`;
console.log('image1=' + image1);

const LoadingContent = () => {
    return (
        <div className="footer-widget mb-40 footer-widget__blog">
            <h3 className="footer-widget__title">Download Android app</h3>
            <a target="_blank" href='https://play.google.com/store/apps/details?id=com.jciindia.directory&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'><img width="300px" alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png'/></a>
        </div>
    );
};

export default LoadingContent;
